module.exports = __webpack_public_path__ + "img/qisi-sq.41859177.png";